import React, { useState } from 'react'

import {
  UIBottomSheet,
  UIButton,
  UIFlex,
  UIRadio,
  UIRadioGroup,
  UISpacing,
  UIText,
} from 'components'

import IcWhatsapp from '@interco/icons/core/brands/ic_whatsapp'
import IcMessage from '@interco/icons/core/media-communication/ic_message'
import IcEvelope from '@interco/icons/core/media-communication/ic_envelope'

import { TChannel, TResendBottomsheetProps } from './types'

const CHANNELS: TChannel[] = [
  {
    name: 'WHATSAPP',
    description: 'Whatsapp',
    icon: <IcWhatsapp height={22} width={22} color="#25D366" />,
  },
  {
    name: 'SMS',
    description: 'SMS',
    icon: <IcMessage height={22} width={22} color="var(--gray500)" />,
  },
  {
    name: 'EMAIL',
    description: 'Email',
    icon: <IcEvelope height={22} width={22} color="var(--gray500)" />,
  },
]

export const ResendBottomsheet = ({
  resendOptions,
  onClose,
  onConfirm,
}: TResendBottomsheetProps) => {
  const [channel, setChannel] = useState<string | undefined>(undefined)
  return (
    <UIBottomSheet onClose={onClose}>
      <UIFlex direction="column" alignItems="normal">
        <UIText variant="headline-h3" semiBold>
          Como deseja receber o código?
        </UIText>

        <UISpacing mb="sm" />

        <UIRadioGroup
          name="channel"
          value={channel}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setChannel(e.target.value)}
        >
          {CHANNELS.filter((_channel) => resendOptions.includes(_channel.name)).map((_channel) => (
            <UIRadio
              key={_channel.name}
              id={_channel.name}
              value={_channel.name}
              reversed
              label={
                <UIFlex direction="row" alignItems="center" gap="8px">
                  {_channel.icon}
                  <UIText variant="body-3">{_channel.description}</UIText>
                </UIFlex>
              }
              style={{ justifyContent: 'space-between' }}
            />
          ))}
        </UIRadioGroup>
        <UISpacing mb="sm" />
        <UIButton onClick={() => channel && onConfirm(channel)} disabled={!channel}>
          Confirmar
        </UIButton>
        <UISpacing mb="xs" />
        <UIButton variant="secondary" onClick={onClose}>
          Voltar
        </UIButton>
      </UIFlex>
    </UIBottomSheet>
  )
}
